/* Maison Lamora — Room viewer.
   Composites the configured chandelier onto a room background (built-in
   illustrated rooms, merchant-uploaded rooms, or the customer's own photo).
   new LamoraRoomViewer(rootEl, { rooms: [{name, src}], getChandelier: () => ({ src, widthCm }) }) */
(function () {
  var W = 1600, H = 1000;

  function room(name, body, opts) {
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '">' + body + '</svg>';
    return Object.assign({ name: name, src: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg), anchorX: 0.5, ceilingY: 0.2, targetY: 0.25, pxPerCm: 3.2 }, opts || {});
  }

  function grad(id, a, b, vertical) {
    return '<linearGradient id="' + id + '" x1="0" y1="0" x2="' + (vertical ? 0 : 1) + '" y2="' + (vertical ? 1 : 0) + '"><stop offset="0" stop-color="' + a + '"/><stop offset="1" stop-color="' + b + '"/></linearGradient>';
  }

  // One-point perspective shell: back wall, ceiling, floor, side walls.
  function shell(p) {
    var bx0 = p.bx0, bx1 = p.bx1, by0 = p.by0, by1 = p.by1;
    return '<defs>' + grad('wall', p.wallA, p.wallB, true) + grad('floor', p.floorA, p.floorB, true) + grad('side', p.sideA, p.sideB) + grad('side2', p.sideB, p.sideA) +
      '<radialGradient id="warm" cx=".5" cy=".3" r=".7"><stop offset="0" stop-color="#fff2d6" stop-opacity=".35"/><stop offset="1" stop-color="#000" stop-opacity=".25"/></radialGradient></defs>' +
      '<rect width="1600" height="1000" fill="' + p.ceil + '"/>' +
      '<polygon points="0,0 1600,0 ' + bx1 + ',' + by0 + ' ' + bx0 + ',' + by0 + '" fill="' + p.ceil + '"/>' +
      '<polygon points="0,0 ' + bx0 + ',' + by0 + ' ' + bx0 + ',' + by1 + ' 0,1000" fill="url(#side)"/>' +
      '<polygon points="1600,0 ' + bx1 + ',' + by0 + ' ' + bx1 + ',' + by1 + ' 1600,1000" fill="url(#side2)"/>' +
      '<rect x="' + bx0 + '" y="' + by0 + '" width="' + (bx1 - bx0) + '" height="' + (by1 - by0) + '" fill="url(#wall)"/>' +
      '<polygon points="0,1000 ' + bx0 + ',' + by1 + ' ' + bx1 + ',' + by1 + ' 1600,1000" fill="url(#floor)"/>' +
      '<line x1="0" y1="0" x2="' + bx0 + '" y2="' + by0 + '" stroke="#000" stroke-opacity=".06"/><line x1="1600" y1="0" x2="' + bx1 + '" y2="' + by0 + '" stroke="#000" stroke-opacity=".06"/>' +
      '<rect x="' + bx0 + '" y="' + (by0) + '" width="' + (bx1 - bx0) + '" height="10" fill="#000" opacity=".05"/>';
  }

  var BUILT_IN = [
    room('Dining room',
      shell({ bx0: 330, bx1: 1270, by0: 150, by1: 720, ceil: '#ece5d8', wallA: '#e3d9c7', wallB: '#d6cab4', sideA: '#cfc2aa', sideB: '#ddd3c0', floorA: '#8a6d4d', floorB: '#5b4531' }) +
      // tall windows
      '<g fill="#f7f3ea" stroke="#b9ab92" stroke-width="4"><rect x="420" y="250" width="180" height="380"/><rect x="1000" y="250" width="180" height="380"/></g>' +
      '<g stroke="#b9ab92" stroke-width="3"><line x1="510" y1="250" x2="510" y2="630"/><line x1="1090" y1="250" x2="1090" y2="630"/><line x1="420" y1="440" x2="600" y2="440"/><line x1="1000" y1="440" x2="1180" y2="440"/></g>' +
      '<rect x="690" y="290" width="220" height="280" fill="#2b2620" opacity=".85"/><rect x="705" y="305" width="190" height="250" fill="#6f6252"/>' +
      // table
      '<ellipse cx="800" cy="905" rx="480" ry="40" fill="#000" opacity=".18"/>' +
      '<polygon points="430,760 1170,760 1260,820 340,820" fill="#3a2d22"/><rect x="340" y="820" width="920" height="16" fill="#2a2019"/>' +
      '<rect x="400" y="836" width="18" height="120" fill="#2a2019"/><rect x="1182" y="836" width="18" height="120" fill="#2a2019"/>' +
      '<g fill="#cdbfa6" stroke="#9c8c72" stroke-width="2"><path d="M470 640h90v130h-90z"/><path d="M1040 640h90v130h-90z"/><path d="M620 650h80v110h-80z"/><path d="M900 650h80v110h-80z"/></g>' +
      '<g fill="#e9e2d4"><ellipse cx="800" cy="778" rx="36" ry="8"/></g><rect x="792" y="730" width="16" height="48" fill="#9A7B4F"/>',
      { ceilingY: 0.0, targetY: 0.16, pxPerCm: 4.2 }),

    room('Grand foyer',
      shell({ bx0: 420, bx1: 1180, by0: 90, by1: 760, ceil: '#f1ece2', wallA: '#efe8dc', wallB: '#dcd1bd', sideA: '#d6cbb6', sideB: '#e7dfd0', floorA: '#e9e3d8', floorB: '#bfb5a4' }) +
      '<path d="M640 760V360a160 160 0 0 1 320 0v400z" fill="#2b2620"/><path d="M660 760V365a140 140 0 0 1 280 0v395z" fill="#4a4034"/>' +
      '<path d="M640 360a160 160 0 0 1 320 0" fill="none" stroke="#9A7B4F" stroke-width="4"/>' +
      '<g fill="none" stroke="#bdb19c" stroke-width="3"><rect x="470" y="200" width="120" height="420"/><rect x="1010" y="200" width="120" height="420"/></g>' +
      '<g stroke="#000" stroke-opacity=".07"><line x1="0" y1="1000" x2="800" y2="760"/><line x1="1600" y1="1000" x2="800" y2="760"/><line x1="800" y1="1000" x2="800" y2="760"/></g>' +
      '<ellipse cx="800" cy="900" rx="330" ry="60" fill="#b9ae9c" opacity=".35"/>' +
      '<rect x="700" y="800" width="200" height="90" fill="#2b2620"/><ellipse cx="800" cy="800" rx="100" ry="12" fill="#3a332b"/><path d="M780 800c-30-60 10-110 20-120 10 10 50 60 20 120z" fill="#6d7a5c"/>',
      { ceilingY: 0.0, targetY: 0.12, pxPerCm: 3.0 }),

    room('Living salon',
      shell({ bx0: 300, bx1: 1300, by0: 170, by1: 700, ceil: '#e8e2d6', wallA: '#5d6159', wallB: '#4a4d46', sideA: '#3e413b', sideB: '#555850', floorA: '#b9a78c', floorB: '#7e6c55' }) +
      '<g fill="none" stroke="#6c7068" stroke-width="3"><rect x="360" y="230" width="260" height="400"/><rect x="980" y="230" width="260" height="400"/></g>' +
      '<rect x="660" y="340" width="280" height="200" fill="#e9e2d4"/><rect x="672" y="352" width="256" height="176" fill="#c9b99c"/><circle cx="760" cy="430" r="40" fill="#9A7B4F" opacity=".6"/>' +
      '<ellipse cx="800" cy="920" rx="560" ry="60" fill="#e9e2d4" opacity=".5"/>' +
      '<path d="M420 700h760v-60q0-30-30-30H450q-30 0-30 30z" fill="#d8cdb8"/><rect x="400" y="700" width="800" height="120" rx="18" fill="#e7ddcb"/><rect x="420" y="820" width="20" height="30" fill="#2b2620"/><rect x="1160" y="820" width="20" height="30" fill="#2b2620"/>' +
      '<g fill="#cdbfa6"><rect x="470" y="660" width="200" height="60" rx="14"/><rect x="930" y="660" width="200" height="60" rx="14"/></g>' +
      '<ellipse cx="800" cy="905" rx="160" ry="26" fill="#2b2620"/><rect x="660" y="905" width="280" height="10" fill="#1d1a16"/>',
      { ceilingY: 0.0, targetY: 0.2, pxPerCm: 4.4 }),

    room('Stairwell',
      shell({ bx0: 520, bx1: 1080, by0: 60, by1: 860, ceil: '#f2eee6', wallA: '#ece5d9', wallB: '#d8ccb6', sideA: '#cbbfa8', sideB: '#e4dccd', floorA: '#cfc5b3', floorB: '#9e937f' }) +
      '<rect x="700" y="110" width="200" height="420" fill="#f9f6ef" stroke="#bdb19c" stroke-width="4"/><line x1="800" y1="110" x2="800" y2="530" stroke="#bdb19c" stroke-width="3"/>' +
      (function () { var s = ''; for (var i = 0; i < 11; i++) { var y = 1000 - i * 48, x = 80 + i * 60; s += '<polygon points="' + x + ',' + y + ' ' + (x + 520 - i * 18) + ',' + y + ' ' + (x + 520 - i * 18) + ',' + (y - 48) + ' ' + (x + 60) + ',' + (y - 48) + '" fill="' + (i % 2 ? '#e8e0d2' : '#ddd3c2') + '"/>'; } return s; })() +
      '<path d="M80 760 L760 280" stroke="#2b2620" stroke-width="8"/><g stroke="#2b2620" stroke-width="3">' +
      (function () { var s = ''; for (var i = 0; i < 12; i++) { var x = 100 + i * 56, y = 746 - i * 39.5; s += '<line x1="' + x + '" y1="' + y + '" x2="' + x + '" y2="' + (y + 150) + '"/>'; } return s; })() + '</g>',
      { anchorX: 0.56, ceilingY: 0.0, targetY: 0.1, pxPerCm: 2.6 }),

    room('Bedroom',
      shell({ bx0: 320, bx1: 1280, by0: 190, by1: 700, ceil: '#ede7dc', wallA: '#d9c9b8', wallB: '#c6b39e', sideA: '#b9a590', sideB: '#cfbeab', floorA: '#a48462', floorB: '#6c533b' }) +
      '<rect x="560" y="360" width="480" height="300" rx="10" fill="#8f7a64"/><rect x="580" y="380" width="440" height="270" rx="6" fill="#a58f78"/>' +
      '<polygon points="520,640 1080,640 1240,880 360,880" fill="#f1ebe0"/><rect x="360" y="880" width="880" height="50" fill="#e4dccd"/>' +
      '<polygon points="520,640 1080,640 1130,720 470,720" fill="#e8e0d2"/><g fill="#fbf8f2"><rect x="600" y="600" width="170" height="60" rx="14"/><rect x="830" y="600" width="170" height="60" rx="14"/></g>' +
      '<polygon points="560,760 1040,760 1150,880 450,880" fill="#9A7B4F" opacity=".55"/>' +
      '<rect x="400" y="620" width="110" height="90" fill="#3a2d22"/><rect x="1090" y="620" width="110" height="90" fill="#3a2d22"/>',
      { ceilingY: 0.0, targetY: 0.2, pxPerCm: 4.4 })
  ];

  function loadImage(src) {
    return new Promise(function (res, rej) {
      var img = new Image();
      if (/^https?:|^\/\//.test(src)) img.crossOrigin = 'anonymous';
      img.onload = function () { res(img); };
      img.onerror = rej;
      img.src = src;
    });
  }

  function RoomViewer(root, opts) {
    this.root = root;
    this.opts = opts || {};
    var custom = (opts.rooms || []).filter(function (r) { return r && r.src; }).map(function (r) {
      return Object.assign({ anchorX: 0.5, ceilingY: 0, targetY: 0.18, pxPerCm: 0 }, r);
    });
    // Photographed rooms only. The illustrated SVG rooms stay as a last-resort
    // fallback for when no photo room resolves (see verifyRooms).
    this.rooms = custom.length ? custom : BUILT_IN.slice();
    this.fallbackRooms = BUILT_IN;
    this.state = { room: 0, x: null, y: null, scale: 1, lit: 0.6, manualScale: false };
    this.canvas = root.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.canvas.width = W; this.canvas.height = H;
    this.buildUI();
    this.bind();
    this.selectRoom(0);
    this.verifyRooms();
    var self = this;
    document.addEventListener('lamora:light', function () { self.relight(); });
  }

  /* Photographs that are not uploaded yet quietly drop out of the strip. */
  // Re-load just the backdrop when the global daylight switch flips.
  RoomViewer.prototype.relight = function () {
    var self = this, r = this.rooms[this.state.room];
    if (!r) return;
    var src = this.roomSrc(r);
    if (src === this._bgSrc) return;
    this.root.classList.add('is-loading');
    loadImage(src).then(function (img) {
      self._bgSrc = src;
      self.bg = img;
      self.draw();
      self.root.classList.remove('is-loading');
    }).catch(function () { self.root.classList.remove('is-loading'); });
  };

  RoomViewer.prototype.verifyRooms = function () {
    var self = this;
    this.rooms.filter(function (r) { return r.optional; }).forEach(function (r) {
      var probe = new Image();
      probe.onerror = function () {
        var i = self.rooms.indexOf(r);
        if (i < 0) return;
        var wasActive = self.state.room === i;
        self.rooms.splice(i, 1);
        self.buildUI();
        self.selectRoom(wasActive ? 0 : Math.max(0, self.state.room > i ? self.state.room - 1 : self.state.room));
      };
      probe.src = r.src;
    });
  };

  RoomViewer.prototype.buildUI = function () {
    var self = this, strip = this.root.querySelector('[data-room-strip]');
    strip.innerHTML = '';
    this.rooms.forEach(function (r, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'room-thumb'; b.setAttribute('aria-label', r.name);
      b.innerHTML = '<img src="' + r.src + '" alt="" loading="lazy"><span>' + r.name + '</span>';
      b.addEventListener('click', function () { self.selectRoom(i); });
      strip.appendChild(b);
    });
  };

  RoomViewer.prototype.bind = function () {
    var self = this, c = this.canvas, drag = null;
    function pt(e) {
      var r = c.getBoundingClientRect(), t = e.touches ? e.touches[0] : e;
      return { x: (t.clientX - r.left) * (W / r.width), y: (t.clientY - r.top) * (H / r.height) };
    }
    function down(e) { var p = pt(e); drag = { dx: p.x - self.state.x, dy: p.y - self.state.y }; c.classList.add('is-dragging'); e.preventDefault(); }
    function move(e) { if (!drag) return; var p = pt(e); self.state.x = p.x - drag.dx; self.state.y = p.y - drag.dy; self.draw(); e.preventDefault(); }
    function up() { drag = null; c.classList.remove('is-dragging'); }
    c.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    var pinch = null;
    c.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinch = { d: Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY), scale: self.state.scale };
        e.preventDefault(); return;
      }
      down(e);
    }, { passive: false });
    c.addEventListener('touchmove', function (e) {
      if (pinch && e.touches.length === 2) {
        var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        self.setScale(pinch.scale * (d / pinch.d), true);
        e.preventDefault(); return;
      }
      move(e);
    }, { passive: false });
    c.addEventListener('touchend', function (e) { if (e.touches.length < 2) pinch = null; up(); });
    c.addEventListener('wheel', function (e) { e.preventDefault(); self.setScale(self.state.scale * (e.deltaY < 0 ? 1.05 : 0.95), true); }, { passive: false });

    var scale = this.root.querySelector('[data-room-scale]');
    if (scale) scale.addEventListener('input', function () { self.setScale(parseFloat(scale.value), true); });
    var lit = this.root.querySelector('[data-room-lit]');
    if (lit) lit.addEventListener('input', function () { self.state.lit = parseFloat(lit.value); self.refresh(); });
    var rot = this.root.querySelector('[data-room-rotate]');
    if (rot) rot.addEventListener('input', function () {
      if (self.opts.onRotate) self.opts.onRotate(parseFloat(rot.value));
    });
    var upload = this.root.querySelector('[data-room-upload]');
    if (upload) upload.addEventListener('change', function () {
      var f = upload.files && upload.files[0];
      if (!f) return;
      var url = URL.createObjectURL(f);
      self.rooms.unshift({ name: 'Your room', src: url, anchorX: 0.5, ceilingY: 0, targetY: 0.18, pxPerCm: 0, own: true });
      self.buildUI();
      self.selectRoom(0);
    });
    var reset = this.root.querySelector('[data-room-reset]');
    if (reset) reset.addEventListener('click', function () { self.state.manualScale = false; self.selectRoom(self.state.room); });
    var save = this.root.querySelector('[data-room-save]');
    if (save) save.addEventListener('click', function () { self.download(); });
  };

  RoomViewer.prototype.setScale = function (v, manual) {
    this.state.scale = Math.min(3, Math.max(0.2, v));
    if (manual) this.state.manualScale = true;
    var s = this.root.querySelector('[data-room-scale]');
    if (s) s.value = this.state.scale;
    this.draw();
  };

  // Which exposure of a room to show, following <html data-light>.
  RoomViewer.prototype.roomSrc = function (r) {
    var night = document.documentElement.getAttribute('data-light') === 'night';
    return (night && r.night) ? r.night : r.src;
  };

  RoomViewer.prototype.selectRoom = function (i) {
    var self = this, r = this.rooms[i];
    this.state.room = i;
    this.root.querySelectorAll('.room-thumb').forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
    this.root.classList.add('is-loading');
    loadImage(this.roomSrc(r)).then(function (img) {
      self.bg = img;
      self._bgSrc = self.roomSrc(r);
      self.state.x = r.anchorX * W;
      self.state.y = r.targetY * H;
      self.state.manualScale = false;
      return self.refresh();
    }).catch(function () { self.root.classList.remove('is-loading'); });
  };

  // Re-fetch the chandelier image from the configurator (called on option change).
  RoomViewer.prototype.refresh = function () {
    var self = this, ch = this.opts.getChandelier({ lit: this.state.lit });
    var source = ch.canvas ? Promise.resolve(ch.canvas) : loadImage(ch.src);
    return source.then(function (img) {
      if (ch.canvas) { img.naturalWidth = img.width; img.naturalHeight = img.height; }
      self.ch = img; self.chInfo = ch;
      if (!self.state.manualScale) {
        var r = self.rooms[self.state.room];
        var ppc = r.pxPerCm || (W / 420); // unknown photo: assume ~4.2 m visible width
        if (ch.pxPerCm) self.setScale(ppc / ch.pxPerCm, false);
        else self.setScale((ch.widthCm * ppc) / (img.naturalWidth * (ch.ringFraction || 0.9)), false);
      } else self.draw();
      self.root.classList.remove('is-loading');
      if (ch.revoke) setTimeout(function () { URL.revokeObjectURL(ch.src); }, 0);
    });
  };

  RoomViewer.prototype.draw = function () {
    var ctx = this.ctx, bg = this.bg, ch = this.ch, s = this.state, r = this.rooms[s.room];
    if (!bg) return;
    ctx.clearRect(0, 0, W, H);
    // cover-fit background
    var k = Math.max(W / bg.naturalWidth, H / bg.naturalHeight);
    var bw = bg.naturalWidth * k, bh = bg.naturalHeight * k;
    ctx.drawImage(bg, (W - bw) / 2, (H - bh) / 2, bw, bh);
    // dim room slightly when chandelier is lit so the glow reads
    if (s.lit > 0) { ctx.fillStyle = 'rgba(10,8,5,' + (0.18 * s.lit) + ')'; ctx.fillRect(0, 0, W, H); }
    if (!ch) return;
    var w = (ch.naturalWidth || ch.width) * s.scale, h = (ch.naturalHeight || ch.height) * s.scale;
    var x = s.x - w / 2, y = s.y;
    // suspension cable from ceiling
    var ceil = (r.ceilingY || 0) * H;
    if (y > ceil) {
      ctx.strokeStyle = 'rgba(40,34,26,.75)'; ctx.lineWidth = Math.max(1, 1.5 * s.scale);
      ctx.beginPath(); ctx.moveTo(s.x, ceil); ctx.lineTo(s.x, y + 6 * s.scale); ctx.stroke();
    }
    // warm light pool
    if (s.lit > 0) {
      ctx.save();
      ctx.globalCompositeOperation = 'screen';
      var cy = y + h * 0.45, rad = Math.max(w, h) * 1.4;
      var g = ctx.createRadialGradient(s.x, cy, 0, s.x, cy, rad);
      g.addColorStop(0, 'rgba(255,226,170,' + (0.45 * s.lit) + ')');
      g.addColorStop(0.4, 'rgba(255,210,140,' + (0.15 * s.lit) + ')');
      g.addColorStop(1, 'rgba(255,210,140,0)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      ctx.restore();
    }
    // soft shadow on ceiling side, then the piece
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.25)'; ctx.shadowBlur = 18 * s.scale; ctx.shadowOffsetY = 8 * s.scale;
    ctx.drawImage(ch, x, y, w, h);
    ctx.restore();
  };

  RoomViewer.prototype.download = function () {
    var a = document.createElement('a');
    try {
      this.canvas.toBlob(function (b) {
        if (!b) return;
        a.href = URL.createObjectURL(b);
        a.download = 'lamora-in-your-room.png';
        document.body.appendChild(a); a.click(); a.remove();
      }, 'image/png');
    } catch (e) {
      var m = this.root.querySelector('[data-room-msg]');
      if (m) m.textContent = 'This room image cannot be saved from the browser. Try a built-in room or your own photo.';
    }
  };

  RoomViewer.BUILT_IN = BUILT_IN;
  window.LamoraRoomViewer = RoomViewer;
})();
